import * as B from '@blueprintjs/core';
import React from 'react';

const LineIcon: React.FunctionComponent<{
  color?: string;
  size?: number;
}> = ({color, size = 16}) => (
  <B.Icon
    style={{cursor: 'pointer'}}
    icon={
      <span className="bp5-icon">
        <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="17" r="2.5" fill={color} />
          <circle cx="17" cy="3" r="2.5" fill={color} />
          <line
            x1="3"
            y1="17"
            x2="17"
            y2="3"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
      </span>
    }
  />
);

export default LineIcon;
